    <div class="bg-white pl-3 py-3 pr-0 not-verified verification-process-container position-relative d-flex align-items-center justify-content-between container-shadow">
        <div class="w-75">
            <p class="heading-4 text-white">{{dataObj?.heading_text}}</p>
            <button 
                *ngIf="dataObj?.button!=null" 
                class="btn-design small filled mt-3 px-3" 
                (click)="showWebModal('verify_step1');emitButtonClicked.emit()" 
                >{{dataObj?.button?.text || dataObj?.text}}
            </button>
        </div>
        <img src="assets/themes/images/verification-pending.svg" class="mr-3" width="88px"/>
    </div>